export class DynamicFormHeader {
  id: number;
  authorUserId: number;
  header: string;
}
